var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageLayoutForms", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "h1",
              {
                staticClass:
                  "pdp-mandate-onboarding-legal-representative__title typographies-heading-h1"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t.__("pdp.mandate.Onboarding.title")) +
                    "\n        "
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("CompassInformationBanner", {
              attrs: {
                title: _vm.$t.__(
                  "pdp.mandate.OnboardingLegalRepresentative.InformationBanner.title"
                ),
                sourceIllustration:
                  "/ressources/logged/img/illustrations/pdp/invoicing-signature.svg"
              },
              scopedSlots: _vm._u([
                {
                  key: "description",
                  fn: function() {
                    return [
                      _c("div", {
                        staticClass:
                          "pdp-mandate-onboarding-legal-representative__information typographies-paragraph-medium-regular",
                        domProps: {
                          innerHTML: _vm._s(_vm.informationBannerDescription)
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "h2",
              {
                staticClass:
                  "pdp-mandate-onboarding-legal-representative__subtitle typographies-heading-h2"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__(
                        "pdp.mandate.OnboardingLegalRepresentative.subtitle"
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pdp-mandate-onboarding-legal-representative__form"
              },
              [
                _c(
                  "CompassFormItem",
                  {
                    attrs: {
                      label: _vm.$t.__(
                        "pdp.mandate.OnboardingLegalRepresentative.formItem.email"
                      ),
                      size: "large",
                      error: _vm.errors.email
                        ? _vm.$t.__(
                            "common.labels.please_enter_a_valid_email_address"
                          )
                        : ""
                    }
                  },
                  [
                    _c("CompassInput", {
                      attrs: {
                        type: "email",
                        size: "large",
                        error: _vm.errors.email
                      },
                      on: {
                        blur: function($event) {
                          _vm.errors.email = !!_vm.email
                            ? !_vm.validateEmail(_vm.email)
                            : false
                        },
                        input: _vm.handleEmailInput
                      },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "CompassFormItem",
                  {
                    attrs: {
                      label: _vm.$t.__(
                        "pdp.mandate.OnboardingLegalRepresentative.formItem.mobile"
                      ),
                      size: "large",
                      error: _vm.errors.mobile
                        ? _vm.$t.__(
                            "common.labels.please_enter_a_valid_phone_number"
                          )
                        : ""
                    }
                  },
                  [
                    _c("CompassTelInput", {
                      attrs: {
                        value: _vm.mobile,
                        size: "large",
                        defaultCountry: "fr",
                        error: _vm.errors.mobile
                      },
                      on: {
                        input: function($event) {
                          _vm.errors.mobile = false
                        },
                        blur: function($event) {
                          return _vm.handleTelInputBlur($event)
                        },
                        validate: function(value) {
                          return _vm.updatePhoneNumber(value)
                        },
                        "country-changed": function($event) {
                          return _vm.handleCountryChange($event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pdp-mandate-onboarding-legal-representative__help"
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      "/ressources/logged/img/illustrations/pdp/shield-check.svg",
                    alt: "Information",
                    height: "20",
                    width: "20"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "pdp-mandate-onboarding-legal-representative__help-content typographies-paragraph-medium-regular"
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t.__(
                              "pdp.mandate.OnboardingLegalRepresentative.helpText.1"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t.__(
                            "pdp.mandate.OnboardingLegalRepresentative.helpText.2",
                            {
                              linkStart:
                                "<a href='https://go.sellsy.com/informations-legales/confidentialite-des-donnees' target='_blank' rel='noopener noreferrer'>",
                              linkEnd: "</a>"
                            }
                          )
                        )
                      }
                    })
                  ]
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("FooterFullPage", {
              attrs: {
                primaryAction: _vm.primaryAction,
                secondaryActions: _vm.secondaryActions
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }